import {notificationFeedService} from "../services";
import {useNotificationFeedStore} from "../store";
import type {NotificationItem} from "../types";

function readPayloadNumber(
  payload: Record<string, unknown> | undefined,
  key: string,
): number | undefined {
  const value = payload?.[key];
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === "string") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
}

function getBreakAlertShiftBreakId(item: NotificationItem): number | undefined {
  return (
    readPayloadNumber(item.payload, "shift_break_id") ??
    (item.type === "shift.break_alert" && typeof item.subject.id === "number"
      ? item.subject.id
      : undefined)
  );
}

function getEndAlertShiftId(item: NotificationItem): number | undefined {
  return (
    readPayloadNumber(item.payload, "shift_id") ??
    (item.type === "shift.end_alert" && typeof item.subject.id === "number"
      ? item.subject.id
      : undefined)
  );
}

/** Immediate bell cleanup before feed refetch (complements server `notifications.discarded`). */
export function optimisticClearShiftComplianceNotifications(options: {
  shiftBreakId?: number;
  shiftId?: number;
}): void {
  const {shiftBreakId, shiftId} = options;
  if (shiftBreakId == null && shiftId == null) {
    return;
  }

  useNotificationFeedStore.setState((state) => {
    const items = state.items.filter((item) => {
      if (shiftBreakId != null && item.type === "shift.break_alert") {
        if (getBreakAlertShiftBreakId(item) === shiftBreakId) {
          return false;
        }
      }
      if (shiftId != null && item.type === "shift.end_alert") {
        if (getEndAlertShiftId(item) === shiftId) {
          return false;
        }
      }
      return true;
    });

    if (items.length === state.items.length) {
      return state;
    }

    return {
      ...state,
      items,
      unreadCount: notificationFeedService.getUnreadNonDiscardedCount(items),
    };
  });
}
